import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import MOTOLayout from "@/components/MOTOLayout";
import LoginPage from "@/pages/LoginPage";
import PaymentPage from "@/pages/PaymentPage";
import RefundPage from "@/pages/RefundPage";
import HistoryPage from "@/pages/HistoryPage";
import SettingsPage from "@/pages/SettingsPage";
import MOTOPage from "@/pages/MOTOPage";
import { Loader2 } from "lucide-react";

function AppContent() {
  const { user, isAuthenticated, loading, passwordsConfigured } = useAuth();

  // Show loading spinner while checking auth
  if (loading || passwordsConfigured === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // Show login/setup page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // MOTO user only has access to MOTO page
  if (user?.role === "moto") {
    return (
      <Routes>
        <Route path="/moto" element={<MOTOLayout />}>
          <Route index element={<MOTOPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/moto" replace />} />
      </Routes>
    );
  }

  // Admin and POS users use the main layout
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<PaymentPage />} />
        <Route path="moto" element={<MOTOPage />} />
        <Route path="refund" element={<RefundPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
